export const rolesObj = {
  nonAdmin: {
    serverValue: "NonAdmin",
    number: 0
  },
  coreTierAdmin: {
    serverValue: "CoreTierAdmin",
    number: 1
  },
  plusTierAdmin: {
    serverValue: "PlusTierAdmin",
    number: 2
  },
  proTierAdmin: {
    serverValue: "ProTierAdmin",
    number: 3
  },
  wtAdmin: {
    serverValue: "WT Admin",
    number: 4
  },
  superWtAdmin: {
    serverValue: "Super WT Admin",
    number: 10
  }
};

export const allAdminValues = Object.keys(rolesObj)
  .filter(key => key !== "nonAdmin")
  .map(key => {
    return rolesObj[key].serverValue;
  });
